import Axios from '../axios'
import { serialize } from '../utility/serialization'

export function requestGetEnrollments({ communityId, page, perPage, search, sortField, sortValue, filters, signal }) {
  const requestUrl = `api/v1/communities/${communityId}/enrollments`
  const params = {
    page,
    perPage,
    search,
    sortField,
    sortValue,
    ...filters,
  }
  return Axios.get(requestUrl, { params: serialize(params), signal })
}

export function requestGetCourseEnrollments({ courseId, page, perPage, search, sortField, sortValue, filters, signal }) {
  const requestUrl = `api/v1/courses/${courseId}/enrollments`
  const params = {
    page,
    perPage,
    search,
    sortField,
    sortValue,
    ...filters,
  }
  return Axios.get(requestUrl, { params: serialize(params), signal })
}

export function requestGetEnrollment({ communityId, enrollmentId }) {
  const requestUrl = `api/v1/communities/${communityId}/enrollments/${enrollmentId}`
  return Axios.get(requestUrl)
}

export function requestExportEnrollments({ communityId, filters }) {
  const requestUrl = `api/v1/communities/${communityId}/enrollments/export`
  return Axios.post(requestUrl, serialize({ ...filters }))
}
